require('./bootstrap');
require('./swiper');

import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
import 'jquery-ui/ui/widgets/datepicker.js';

import 'video.js/dist/video.js';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/sea/index.css';

import Sortable from 'sortablejs';
window.Sortable = Sortable;
